import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

class FormInput extends Component {
  state = {
    internalValue: '',
    firstLoadDone: false,
  };

  // componentDidUpdate = (prevProps, prevState) => {
  //   const { getValue } = this.props;
  //   if (prevProps !== this.props && getValue() !== undefined) {
  //     if (prevState.internalValue !== getValue()) {
  //       this.setState({
  //         internalValue: getValue(),
  //       });
  //     }
  //   }
  // };

  componentDidMount() {
    const { value } = this.props;
    this.setState({ internalValue: value });
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props;
    const { firstLoadDone } = this.state;
    if (prevProps.value !== value && !firstLoadDone) {
      this.setState({ internalValue: value, firstLoadDone: true });
    }
  }

  changeValue = (e) => {
    this.setState({
      internalValue: e.currentTarget.value,
    });
    if (this.props.storeText) {
      const { storeText, name } = this.props;
      return storeText(name, e.currentTarget.value);
    }
    return null;
  };

  render() {
    const { internalValue } = this.state;

    const {
      name, type, title, slugError, storeText, action, ignorePasswordManager, autoComplete,
    } = this.props;

    // Build extra attributes for password manager ignore
    const extraAttrs = {};
    if (ignorePasswordManager) {
      extraAttrs['data-1p-ignore'] = 'true';
      extraAttrs['data-lpignore'] = 'true';
      extraAttrs['data-form-type'] = 'other';
    }
    if (autoComplete) {
      extraAttrs.autoComplete = autoComplete;
    }

    return (
      <div className="w-full">
        <label className="flex flex-col font-americaMonoRegular text-xs uppercase" htmlFor={name}>
          {title}
          {
            <input
              onChange={this.changeValue}
              onBlur={() => {
                if (storeText) {
                  storeText(name, internalValue);
                }
              }}
              name={name}
              type={type || 'text'}
              value={internalValue || ''}
              disabled={action === 'display' || (action === 'modify' && slugError !== undefined)}
              className={`mt-2 rounded-full border-1 p-2 ${action === 'create' && 'bg-white'} outline-none  ${slugError && action === 'create' ? ' text-red ' : ' border-black text-black '} ${(action === 'display' || action === 'delete') && 'bg-grey mb-2'} ${action === 'modify' && slugError === undefined ? 'bg-white' : 'bg-grey'} ${action === 'modify'
                && 'mb-2'}`}
              {...extraAttrs}
            />
          }
        </label>
        {action === 'create' && <span className="flex flex-col text-red mt-4" />}
      </div>
    );
  }
}

FormInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  slugError: PropTypes.bool,
  storeText: PropTypes.func,
  action: PropTypes.string.isRequired,
  value: PropTypes.string,
  title: PropTypes.string,
};

FormInput.defaultProps = {
  type: '',
  slugError: undefined,
  storeText: null,
  value: '',
  title: '',
};

export default FormInput;
